import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import Home from "@/pages/Home";
import Analyse from "@/pages/Analyse";
import Rapport from "@/pages/Rapport";
import BetalingSucces from "@/pages/BetalingSucces";
import BetalingGeannuleerd from "@/pages/BetalingGeannuleerd";
import HoeWerktHet from "@/pages/HoeWerktHet";
import Prijzen from "@/pages/Prijzen";
import OverOns from "@/pages/OverOns";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Voorwaarden from "@/pages/Voorwaarden";
import Cookiebeleid from "@/pages/Cookiebeleid";
import VoorBedrijven from "@/pages/VoorBedrijven";
import VoorBedrijvenAanmelden from "@/pages/VoorBedrijvenAanmelden";
import VoorBedrijvenBedankt from "@/pages/VoorBedrijvenBedankt";
import BrancheLanding from "@/pages/BrancheLanding";
import PartnerProfile from "@/pages/PartnerProfile";
import SitemapPage from "@/pages/Sitemap";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAnalyses from "@/pages/admin/AdminAnalyses";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminConfig from "@/pages/admin/AdminConfig";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminRevenue from "@/pages/admin/AdminRevenue";
import AdminDiscountCodes from "@/pages/admin/AdminDiscountCodes";
import AdminBusinesses from "@/pages/admin/AdminBusinesses";
import AdminLegalPages from "@/pages/admin/AdminLegalPages";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminGdpr from "@/pages/admin/AdminGdpr";
import Credits from "@/pages/Credits";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/analyse" element={<Analyse />} />
          <Route path="/rapport/:orderId" element={<Rapport />} />
          <Route path="/betaling-succes" element={<BetalingSucces />} />
          <Route path="/betaling-geannuleerd" element={<BetalingGeannuleerd />} />
          <Route path="/hoe-werkt-het" element={<HoeWerktHet />} />
          <Route path="/prijzen" element={<Prijzen />} />
          <Route path="/over-ons" element={<OverOns />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/algemene-voorwaarden" element={<Voorwaarden />} />
          <Route path="/cookiebeleid" element={<Cookiebeleid />} />
          <Route path="/voor-bedrijven" element={<VoorBedrijven />} />
          <Route path="/voor-bedrijven/aanmelden" element={<VoorBedrijvenAanmelden />} />
          <Route path="/voor-bedrijven/bedankt" element={<VoorBedrijvenBedankt />} />

          {/* SEO landing pages — branche / branche+city */}
          <Route path="/offertes/:branche" element={<BrancheLanding />} />
          <Route path="/offertes/:branche/:stad" element={<BrancheLanding />} />

          {/* Public partner profile (live Google reviews + LocalBusiness JSON-LD) */}
          <Route path="/partner/:slug" element={<PartnerProfile />} />

          {/* HTML sitemap (user-facing + SEO) */}
          <Route path="/sitemap" element={<SitemapPage />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/revenue" element={<AdminRevenue />} />
            <Route path="/admin/analyses" element={<AdminAnalyses />} />
            <Route path="/admin/payments" element={<AdminPayments />} />
            <Route path="/admin/businesses" element={<AdminBusinesses />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/homepage" element={<AdminHomepage />} />
            <Route path="/admin/emails" element={<AdminEmails />} />
            <Route path="/admin/legal-pages" element={<AdminLegalPages />} />
            <Route path="/admin/discount-codes" element={<AdminDiscountCodes />} />
            <Route path="/admin/gdpr" element={<AdminGdpr />} />
            <Route path="/admin/config" element={<AdminConfig />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
